import React from 'react';
import {NavLink as Link} from 'react-router-dom';
import Loading from './../misc/Loading';
import GenerationList from './GenerationList';
import generations from './../../../../model/generation';
import makes from './../../../../model/makes';
import model from './../../../../model/model';
import withRouter from '/src/components/misc/withRouter';


class GenerationsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      generations: [],
      model: [],
      makeid: props.match.params.makeId,
      modelid: props.match.params.id
    };
  }

  UNSAFE_componentWillMount() { // eslint-disable-line camelcase
    Promise.all([
      makes.getById(this.state.makeid),
      generations.generationByModel(this.state.modelid, 2),
      model.getById(this.state.modelid)
    ]).then(([modelid, generations, model]) => {
      document.title = `Admin - Generasjoner - ${model.name}`;
      this.setState({
        generations: generations,
        modelid: modelid,
        model: model
      });
    });
  }

  render() {
    if (this.state.generations.length === 0 && this.state.model.length === 0) {
      return (
        <Loading title="Generasjoner" text="Laster generasjoner" />
      );
    }

    return (
      <section>
        <div className="mf-model">
          <ol className="breadcrumb mf-margin-top-20">

            <li><Link to="/">Forsiden</Link></li>
            <li><Link to="/mypage/">Min Side</Link></li>
            <li><Link to={`/mypage/${this.state.makeid}`}>{this.state.modelid.name}</Link></li>
            <li className="active">{this.state.model.displayname}</li>

          </ol>
          <div className="page-header">
            <div className="pull-right">
              <Link
                to={`/mypage/${this.state.makeid}/generations/${this.state.model.id}/new`}
                className="btn btn-success"
                disabled={this.props.working}
              >
                Opprett ny generasjon
              </Link>
            </div>
            <h1>
              <em>{this.state.model.name}</em> Generasjoner
            </h1>
          </div>
        </div>

        <div>
          {this.state.generations.length === 0 &&
            <p>Det finnes ingen generasjoner for denne bilen. Trykk opprett for å lage en ny.</p>
          }
        </div>

        {this.state.generations.length > 0 &&
          <GenerationList make={this.state.modelid.name} generations={this.state.generations} />
        }
      </section>
    );
  }
}

export default withRouter(GenerationsComponent);
